import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, SpreadGroundImage } from 'editor/src/store/design/types';

const setSpreadBackgroundsReducer = (state: DesignState, action: PayloadAction<SpreadGroundImage[]>) => {
  state.spreadBackgrounds = action.payload;
};

export default setSpreadBackgroundsReducer;
